document.addEventListener('DOMContentLoaded', function() {
    document.getElementById('pincode').addEventListener('keypress', function(e) {
        if (e.key === 'Enter') {
            checkDelivery();
        }
    });
});

const deliveryAvailable = ["700001", "700002", "700003", "700004", "700005", "700006", "700007", "700008", "700009", "700010", "700011", "700012", "700013", "700014", "700015", "700016", "700017", "700018", "700019", "700020", "700021", "700022", "700023", "700024", "700025", "700026", "700027", "700028", "700029", "700030", "700031", "700032", "700033", "700034", "700035", "700036", "700037", "700038", "700039", "700040", "700041", "700042", "700043", "700044", "700045", "700046", "700047", "700053", "700054", "700060", "700061", "700062", "700063", "700067", "700068", "700069", "700070", "700071", "700072", "700073", "700075", "700078", "700082", "700084", "700085", "700086", "700087", "700088", "700092", "700093", "700094", "700095", "700096", "700099", "700100", "700104", "700106", "700107", "700150", "700091", "700106", "700064", "711104", "700098", "711106", "700102", "700101", "700156", "700048", "700055", "700066", "700105", "700148", "700157", "711101", "711102", "711103", "711105", "711108", "711109", "711112", "711204", "711227"];

function checkDelivery() {
    var pincode = document.getElementById('pincode').value;
    if (pincode.length < 6) {
        document.getElementById('deliveryMessage').innerHTML = "Please enter a valid 6-digit Pincode";
        document.querySelector('.innerText').style.display = 'none';
        return;
    }
    var deliveryMessage = getDeliveryMessage(pincode);
    document.getElementById('deliveryMessage').innerHTML = deliveryMessage;
    document.querySelector('.innerText').style.display = 'none';
}

function getDeliveryMessage(pincode) {
    if (deliveryAvailable.includes(pincode)) {
        return "Woohoo! Delivery in <b>1 Day</b> (For all pre-paid orders & Except Sunday)";
    } else {
        return "Delivery in <b>3-5 business days!</b>";
    }
}